import { normalizeSeries } from './normalizers';
import { backEndAPIUrl } from 'constants/values';

export const getDashboard = async values => {
  const url = `${backEndAPIUrl}/dashboard/user`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }
  const response = await fetch(url, {
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });
  if (response.ok) {
    const responseBody = await response.json();
    return normalizeSeries(responseBody);
  } else if (response.status === 422) {
    await response.json();
  }
};
